// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__VGlyY","tabsButttonContainer":"styles_tabsButttonContainer__I4Wvz"};